import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, removeToken, setToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import { hasPermission } from '@/utils/helper/permissionHelper'
// 没有受后端控制的前端页面路由
// import { hasPermission } from '@/utils/helper/permissionHelper'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = [
  '/login',
  '/dingLogin',
  '/dingLoginMobile',
  '/personalityTesting',
  '/dingLoginKuaJie',
  '/dingLoginMobileKanban',
  '/dingLoginDeFeng'
] // 没有重定向白名单

// 控制权限的页面
const pageRouterList = {
  '/index/imageGeneration': 'ai/d/m/basic',
  '/index/generate/promptimage': 'ai/d/m/advanced'
}

router.beforeEach(async (to, from, next) => {
  const current_module = 'pro'
  if (current_module === 'dev') {
    next('/development')
  } else {
    // start progress bar
    NProgress.start()

    // set page title 设置页面标题
    document.title = getPageTitle(to.meta.title)

    // determine whether the user has logged in  确定用户是否已登录
    if (to.query.token) {
      removeToken()
      const rawToken = to.query.token
      setToken(rawToken)
      console.log('[Permission] URL Token长度:', rawToken.length, '| 前20字符:', rawToken.substring(0, 20))
      console.log('[Permission] getToken()返回长度:', getToken()?.length, '| 前20字符:', getToken()?.substring(0, 20))
      await store.dispatch('user/setToken', rawToken)
      return next({
        path: to.path,
        query: {}, // 空对象 = 清空所有参数
        replace: true
      })
    }
    const hasToken = getToken()
    let buttonPermissions = store.getters && store.getters.button_permissions
    buttonPermissions = buttonPermissions['modules'] || []
    if (hasToken) {
      if (whiteList.includes(to.path)) {
        // if is logged in, redirect to the home page  如果已登录，则重定向到主页
        next({ path: '/index/homepage', query: '' })
        NProgress.done()
      } else if (pageRouterList[to.path] && buttonPermissions.length && !hasPermission([pageRouterList[to.path]])) {
        next({ path: '/index/homepage', query: '' })
        NProgress.done()
      } else {
        const hasGetUserInfo = store.getters.name
        if (hasGetUserInfo) {
          next()
        } else {
          try {
            // get user info  获取用户信息
            await store.dispatch('user/getInfo')
            next({ ...to, replace: true })
          } catch (error) {
            // remove token and go to login page to re-login  删除令牌，进入登录页面重新登录

            await store.dispatch('user/resetToken')
            let query = ''
            Message.error(error || 'Has Error')
            if (to.query) {
              query = '&query=' + JSON.stringify(to.query)
            }
            next(`/login?redirect=${to.path}${query}`)
            NProgress.done()
          }
        }
      }
    } else {
      /* has no token */
      if (whiteList.indexOf(to.path) !== -1) {
        // in the free login whitelist, go directly  在免费登录白名单，直接去
        next()
      } else {
        let query = ''
        if (to.query) {
          query = '&query=' + JSON.stringify(to.query)
        }
        // other pages that do not have permission to access are redirected to the login page.
        // 没有访问权限的其他页面被重定向到登录页面。
        next(`/login?redirect=${to.path}${query}`)
        NProgress.done()
      }
    }
  }
})

router.afterEach(() => {
  // finish progress bar  完成进度条
  NProgress.done()
})
